import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import { ImageUploadRequest, ImageUploadResponse } from "../../models/Img.model";

const API_BASE_URL = environment.apiUrl;

export const uploadImage = createAsyncThunk<
  ImageUploadResponse,
  ImageUploadRequest,
  { rejectValue: string }
>(
  'img/uploadImage',
  async (requestData: ImageUploadRequest, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("token", requestData.token);
      formData.append("companyKey", requestData.companyKey);
      formData.append("file", requestData.file);
      formData.append("category", requestData.category);
      formData.append("entityId", requestData.entityId.toString()); // 🆕 הוספה חדשה

      const response = await fetch(`${API_BASE_URL}Image/upload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: ImageUploadResponse = await response.json();

      if (!data.success) return rejectWithValue(data.message || 'Failed to upload image');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);
